export default "__VITE_ASSET__D6g9Mysr__"